import { Component, OnInit, ViewChild } 							from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } 	    from '@angular/forms';
import { ErrorStateMatcher } 										from '@angular/material/core';

import { Router, ActivatedRoute } 								    from '@angular/router';
import { first } 												    from 'rxjs/operators';

import { AlertService, HomeService } 					    	    from '../_services';
import { Globals }     												from '../_helpers';

import { Subject } 													from 'rxjs';
import { Observable,throwError } 									from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil } 				from 'ngx-webcam';

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	    const isSubmitted = form && form.submitted;
	    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})


export class HomeComponent implements OnInit {

	comment= new FormControl();

  	matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isPicTaken = true;
    errorMsg : string;
    returnUrl: string;
    imagePath : string;
    imgfile : File ;
    imageError : boolean;
    exam_id: number;
    localData = {};
    base64 :string;
    isRespMsg = false;
    respMsg:string = '';
    examid:number;
    viva_assessor:number = 0;
    viva_pc:number = 0;
    viva_practical:number = 0;;
    displayText:string = '';

    /* webcam Settings */
	public showWebcam = true;
	public allowCameraSwitch = true;
	public multipleWebcamsAvailable = false;
	public deviceId: string;
	public videoOptions: MediaTrackConstraints = {
	// width: {ideal: 1024},
	// height: {ideal: 576}
	};
	public errors: WebcamInitError[] = [];

	// latest snapshot
	public webcamImage: WebcamImage = null;

	// webcam snapshot trigger
	private trigger: Subject<void> = new Subject<void>();
	// switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
	private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private homeService: HomeService,
        private alertService: AlertService,
        private globals: Globals

    ) {}

    ngOnInit() {
    	this.examid = parseInt(this.route.snapshot.paramMap.get("step"));
    	this.viva_assessor = parseInt(this.route.snapshot.paramMap.get("step2"));
    	this.viva_pc = parseInt(this.route.snapshot.paramMap.get("step3"));
    	this.viva_practical = parseInt(this.route.snapshot.paramMap.get("step4"));
    	this.localData = JSON.parse(localStorage.getItem('currentUser'));
    	this.imageError = false;
    	this.isPicTaken = false;
    	this.imagePath = '/assets/images/camera-icon.png';
    	localStorage.setItem('currentUser', JSON.stringify({id:this.localData['id'], usercode:this.localData['usercode'], exam_id:this.examid, viva_assessor:this.viva_assessor, viva_pc:this.viva_pc, name_assessor:this.localData['name_assessor']}));

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

		WebcamUtil.getAvailableVideoInputs()
		.then((mediaDevices: MediaDeviceInfo[]) => {
			this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
		});
/*		if(this.viva_pc == 1)
		{
			this.displayText = 'MatrixAssess';//PC-Viva/Practical';
		}
		else
		{
			this.displayText = 'Viva/Practical';
		}*/
    }

    public triggerSnapshot(): void {
		this.trigger.next();
		this.imagePath = this.webcamImage.imageAsDataUrl;
		this.isPicTaken = false;
		this.imageError = false;
		this.isRespMsg = false;
		this.submitted = false;
	}

	public toggleWebcam(): void {
		this.showWebcam = !this.showWebcam;
	}

	public handleInitError(error: WebcamInitError): void {
		this.errors.push(error);
	}

	public showNextWebcam(directionOrDeviceId: boolean|string): void {
		// true => move forward through devices
		// false => move backwards through devices
		// string => move to device with given deviceId
		this.nextWebcam.next(directionOrDeviceId);
	}

	public handleImage(webcamImage: WebcamImage): void {
		this.webcamImage = webcamImage;
	}

	public cameraWasSwitched(deviceId: string): void {
		this.deviceId = deviceId;
	}

	public get triggerObservable(): Observable<void> {
		return this.trigger.asObservable();
	}

	public get nextWebcamObservable(): Observable<boolean|string> {
		return this.nextWebcam.asObservable();
	}

	public webCameScreen(): void{
		this.isPicTaken = true;
		this.comment.reset()

	}

	onFileSubmit(){
		if(!this.submitted && this.webcamImage && this.webcamImage.imageAsDataUrl){
			this.homeService.setPhotoGallery(this.globals.root_url,this.localData['usercode'], this.examid, this.localData['id'], this.webcamImage.imageAsDataUrl, this.comment.value)
            .pipe(first())
            .subscribe(
    	        data => {
					
                    if(data.code == 1000){
                        this.imageError = false;
                        this.isRespMsg = true;
                        this.respMsg = "Photo uploaded successfully !! ";//data.status;
                        this.imagePath = '/assets/images/camera-icon.png';
						this.submitted = true;
						this.comment.reset()
                    }
                    else if(data.status == 'COM_TOKEN_ERROR')
						{
							this.loading = false;
							this.router.navigateByUrl('/login');
						}
                    else{
                        this.imageError = true;
                        this.errorMsg = data.status;
                        this.loading = false;
                        this.isRespMsg = false;
                    }
    	        },
    	        error => {
                    this.imageError = true;
                    this.errorMsg = 'Invalid Image !!';
    	            this.alertService.error(error);
    	            this.loading = false;
    	            this.isRespMsg = false;
    	        }
    	    );
		}
		else{
			this.imageError = true;
			this.isRespMsg = false;
		}
	}
	public gotoDExamList(){
        this.router.navigateByUrl('/exam-list'); 
    }
}
